import React from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useNavigate } from 'react-router-dom';
// eslint-disable-next-line import/no-unresolved
import { useDevice } from 'hooks/useResponsive';
import useCloudinary from '../../hooks/useCloudinaryImage';

ProductCard.propTypes = {
  product: PropTypes.any,
};
export default function ProductCard({ product }) {
  const capitalizeFirstLetter = (str) => str?.charAt(0)?.toUpperCase() + str?.slice(1);
  const image = [{ img: '/assets/car.png' }];
  const isMobile = useDevice()?.isMobile;
  const navigate = useNavigate();

  const handleRouter = () => {
    // dispatch(clearVehicleDetails());
    if (product?.isSold !== true) {
      navigate(`/product-single/${product?._id}`);
    }
  };
  // console.log('product', product);
  return (
    <>
      <Stack style={{ minHeight: '210px', position: 'relative', cursor: 'pointer' }} onClick={handleRouter}>
        <Box sx={{ filter: product?.isSold === true && 'grayscale(100%)' }}>
          <Stack position="relative">
            {product?.images?.[0]?.url ? (
              <img
                // eslint-disable-next-line react-hooks/rules-of-hooks
                src={useCloudinary(product.images[0].url, 'w_400 f_auto q_auto')}
                alt=""
                style={{
                  borderRadius: isMobile ? '6px' : '0px',
                  // height: isMobile ? 'auto' : 'auto',
                  aspectRatio: 4 / 3,
                  objectFit: 'cover',
                }}
              />
            ) : (
              <img
                src={image[0]?.img}
                alt=""
                style={{
                  borderRadius: '15px',
                  height: isMobile ? 'auto' : 'auto',
                  aspectRatio: 4 / 3,
                  objectFit: 'cover',
                }}
              />
            )}
            {product?.makeYear > 0 && (
              <Grid
                className="car-year"
                display="flex"
                textAlign="center"
                alignItems="center"
                sx={{
                  borderTopLeftRadius: isMobile ? '4px' : '0px',
                  borderTopRightRadius: isMobile ? '5px' : '0px',
                  borderBottom: isMobile ? '1px solid #565a4c' : '1px solid #FFFFFF33',
                  backgroundColor: isMobile ? '#252e1e' : '#484d4d',
                  top: isMobile ? 0 : -1,
                }}
              >
                {/* <CalendarMonthIcon style={{ fontSize: '10px', color: '#121212', marginRight: '2px' }} /> */}
                <Typography fontSize={10} color="#ffffff" fontWeight={800} width="100%" sx={{ paddingTop: '2px' }}>
                  {product.makeYear}
                </Typography>
              </Grid>
            )}
          </Stack>
          <Typography fontWeight={400} fontSize={16} color="#FFFFFFDE" pl={1} pt={1} minHeight={0}>
            {product?.name}
          </Typography>
          <Typography fontWeight={300} fontSize={12} color="#FFFFFFDE" pl={1} letterSpacing={1}>
            {product?.variant?.name}
          </Typography>
          <Typography fontWeight={300} fontSize={12} color="#FFFFFFDE" pl={1} letterSpacing={0.5}>
            {product?.fuelType && capitalizeFirstLetter(product.fuelType)}
            {product?.fuelType && product?.kiloMeter && (
              <Box
                component="span"
                sx={{
                  mx: 0.5,
                  fontSize: 12,
                  display: 'inline-flex',
                  alignItems: 'center',
                }}
              >
                •
              </Box>
            )}
            {product?.kiloMeter && `${product.kiloMeter}Km`}
          </Typography>
          {product?.price > 0 && (
            // <Typography fontWeight={300} fontSize={12} color="white" pl={1} letterSpacing={1}>
            //  ₹{product?.price}
            // </Typography>
            <Typography fontWeight={500} fontSize={13} color="#FFFFFFDE" pl={1} letterSpacing={1}>
              {new Intl.NumberFormat('en-IN', {
                style: 'currency',
                currency: 'INR',
                maximumFractionDigits: 0,
              }).format(product?.price || 0)}
            </Typography>
          )}
        </Box>

        {product?.isSold ? (
          <img
            src="/assets/images/Product/sold.png"
            alt="Sold"
            style={{ position: 'absolute', right: -5, bottom: 60, width: '100px', height: '100px' }}
          />
        ) : product?.isBooked ? (
          <img
            src="/assets/images/Product/booked.png"
            alt="Booked"
            style={{ position: 'absolute', bottom: 70, right: 10 }}
          />
        ) : null}
      </Stack>
    </>
  );
}
